import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Root, Trigger, Value, Icon as IconWrapper, Viewport, Portal } from "@radix-ui/react-select";
import { Icon } from "../../Icon";
import { SelectContent } from "./SelectContent";
const StylableSelect = ({ className, placeholder, children, "data-testid": dataTestId, ...props }) => {
    return (React.createElement("div", { className: className, "data-testid": dataTestId },
        React.createElement(Root, { ...props },
            React.createElement(Trigger, { className: "SelectTrigger" },
                React.createElement(Value, { placeholder: placeholder }),
                React.createElement(IconWrapper, { className: "SelectIconWrapper" },
                    React.createElement(Icon, { name: "dropdown" }))),
            React.createElement(Portal, null,
                React.createElement(SelectContent, null,
                    React.createElement(Viewport, { className: "SelectViewport" }, children))))));
};
StylableSelect.defaultProps = {
    "data-testid": "Select",
};
export const Select = styled(StylableSelect) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=Select.js.map